import React, { ComponentType, Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { INavMenuProps } from "./navMenu";

const NavMenu = React.lazy(
  () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "slide-outs" */
      "./navMenu"
    ) as unknown as Promise<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      default: ComponentType<any>;
    }>
);

function NavMenuWrapper(props: INavMenuProps) {
  return (
    <>
      {ServerSideService.isServerSide ? undefined : (
        <Suspense fallback={<></>}>
          <NavMenu {...props} />
        </Suspense>
      )}
    </>
  );
}

export default NavMenuWrapper;
